export const PDFBlocks = 'PDF_BLOCKS';
export const Pronunciation = 'PRONUNCIATION';
